(function () {
  if (window.YT && window.YT.Player) return;
  var s = document.createElement('script');
  s.src = 'https://www.youtube.com/iframe_api';
  s.async = true; s.defer = true;

  var cs = document.currentScript;
  var n = cs && (cs.nonce || cs.getAttribute('nonce'));
  if (n) s.setAttribute('nonce', n);

  var first = document.getElementsByTagName('script')[0];
  first.parentNode.insertBefore(s, first);
})();
window.onYouTubeIframeAPIReady = window.onYouTubeIframeAPIReady || function () {
};
